"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyProvider = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var StickyContext = react_1.default.createContext({
    isStickyVacancy: false,
    updateStickyVacancy: function () { return undefined; },
    isStickySearchBar: false,
    updateStickySearchBar: function () { return undefined; },
});
function StickyProvider(_a) {
    var children = _a.children;
    var _b = (0, react_1.useState)(false), isStickyVacancy = _b[0], setIsStickyVacancy = _b[1];
    var _c = (0, react_1.useState)(false), isStickySearchBar = _c[0], setIsStickySearchBar = _c[1];
    var stickyRef = (0, react_1.useRef)(false);
    var updateStickyVacancy = (0, react_1.useCallback)(function (newState) {
        setIsStickyVacancy(newState);
    }, []);
    var updateStickySearchBar = (0, react_1.useCallback)(function (newState) {
        setIsStickySearchBar(newState);
    }, []);
    (0, react_1.useEffect)(function () {
        var handle = function () {
            if (stickyRef.current && window.scrollY < 10) {
                stickyRef.current = false;
                updateStickySearchBar(false);
            }
            if (!stickyRef.current && window.scrollY > 150) {
                stickyRef.current = true;
                updateStickySearchBar(true);
            }
        };
        document.addEventListener('scroll', handle);
        // eslint-disable-next-line consistent-return
        return function () { return document.removeEventListener('scroll', handle); };
    }, [stickyRef, updateStickySearchBar]);
    return ((0, jsx_runtime_1.jsx)(StickyContext.Provider, __assign({ value: { isStickyVacancy: isStickyVacancy, updateStickyVacancy: updateStickyVacancy, isStickySearchBar: isStickySearchBar, updateStickySearchBar: updateStickySearchBar } }, { children: children })));
}
exports.StickyProvider = StickyProvider;
exports.default = StickyContext;
